import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-150376a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-principais-acoes" }
const _hoisted_5 = { class: "ant-btn-group ss-tamanho-completo" }
const _hoisted_6 = {
  type: "button",
  class: "ant-btn ant-btn-secondary ss-btn-recursos"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fechar Caixa", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Reabrir Caixa", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fazer Lançamento", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Imprimir", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Abrir Caixas", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "ss-tela-conteudo" }
const _hoisted_14 = { class: "ss-card ss-card-space" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS:")
], -1))
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = {
  class: "ant-col",
  style: {"flex":"1 1"}
}
const _hoisted_20 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_21 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_22 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_25 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_26 = { class: "ant-input-group-addon" }
const _hoisted_27 = { class: "ss-card ss-card-space ss-tela-conteudo-completo" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-texto-centralizado" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/static/img/ilustracoes/movimentacoes-conta.png",
    width: "250",
    alt: "Movimentações de Caixa"
  }),
  /*#__PURE__*/_createElementVNode("h3", null, "Movimentações de Caixa"),
  /*#__PURE__*/_createElementVNode("span", null, "Selecione uma abertura de caixa para analisar")
], -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "ss-alinhar-texto-esquerda"
}
const _hoisted_32 = { class: "ant-row" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_34 = {
  key: 0,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data:", -1))
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 2 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor :", -1))
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 3,
  class: "acoes-item"
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { key: 4 }
const _hoisted_48 = {
  key: 0,
  class: "ss-valor-pagamento"
}
const _hoisted_49 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_selecionar_caixa = _resolveComponent("selecionar-caixa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_selecionar_abertura_caixa = _resolveComponent("selecionar-abertura-caixa")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_apuracao_caixa_totalizadores = _resolveComponent("apuracao-caixa-totalizadores")!
  const _component_coluna_grade = _resolveComponent("coluna-grade")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_abertura_caixa_modal = _resolveComponent("abertura-caixa-modal")!
  const _component_fechamento_caixa_modal = _resolveComponent("fechamento-caixa-modal")!
  const _component_reabertura_caixa_modal = _resolveComponent("reabertura-caixa-modal")!
  const _component_movimento_caixa_modal = _resolveComponent("movimento-caixa-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: _ctx.telaBase.identificadorRecurso,
          tituloRecurso: _ctx.telaBase.titulo,
          exibirAtalhosTela: true,
          exibirHistoricoTela: true,
          empresasSelecionadas: _ctx.telaBase.empresasSelecionadas,
          "onUpdate:empresasSelecionadas": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
        }, {
          BotoesAcoes: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_dropdown, null, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "ss-icones-acoes",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fecharCaixa && _ctx.fecharCaixa(...args)))
                            }, [
                              _createVNode(_component_icone, {
                                style: {"margin-right":"5px"},
                                nome: "pause-preenchido"
                              }),
                              _hoisted_7
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "ss-icones-acoes",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reabrirCaixa && _ctx.reabrirCaixa(...args)))
                            }, [
                              _createVNode(_component_icone, {
                                style: {"margin-right":"5px"},
                                nome: "play-preenchido"
                              }),
                              _hoisted_8
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "ss-icones-acoes",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.lancarMovimento && _ctx.lancarMovimento(...args)))
                            }, [
                              _createVNode(_component_icone, {
                                style: {"margin-right":"5px"},
                                nome: "editar"
                              }),
                              _hoisted_9
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "ss-icones-acoes",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                            }, [
                              _createVNode(_component_icone, {
                                style: {"margin-right":"5px"},
                                nome: "imprimir"
                              }),
                              _hoisted_10
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_6, [
                      _createVNode(_component_icone, { nome: "menu-pontos" })
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-primary ss-btn-tela",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.abrirCaixas && _ctx.abrirCaixas(...args)))
                }, _hoisted_12)
              ])
            ])
          ]),
          _: 1
        }, 8, ["identificadorRecurso", "tituloRecurso", "empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_selecionar_empresa, {
                  codigoSelecionado: _ctx.state.empresa,
                  "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.empresa) = $event)),
                  empresasEspecificas: _ctx.telaBase.empresasDisponiveis
                }, null, 8, ["codigoSelecionado", "empresasEspecificas"])
              ])
            ], 512), [
              [_vShow, _ctx.telaBase.apresentarEmpresas]
            ]),
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_form_item, {
                      label: "Caixa",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_caixa, {
                          codigoSelecionado: _ctx.state.codigoCaixa,
                          "onUpdate:codigoSelecionado": [
                            _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.codigoCaixa) = $event)),
                            _ctx.buscarCaixa
                          ],
                          empresas: [_ctx.state.empresa]
                        }, null, 8, ["codigoSelecionado", "empresas", "onUpdate:codigoSelecionado"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_form_item, {
                      label: "Data de Operação",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.data,
                          "onUpdate:dataSelecionada": [
                            _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.data) = $event)),
                            _ctx.buscarOperadores
                          ]
                        }, null, 8, ["dataSelecionada", "onUpdate:dataSelecionada"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, {
                      label: "Operadores",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_usuario, {
                          empresas: [_ctx.state.empresa],
                          usuariosEspecificos: _ctx.state.usuarios,
                          codigoSelecionado: _ctx.state.usuario,
                          "onUpdate:codigoSelecionado": [
                            _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.usuario) = $event)),
                            _ctx.limparAberturaCaixa
                          ],
                          disabled: _ctx.state.codigoCaixa === undefined || _ctx.state.codigoCaixa === 0 || _ctx.state.data === '' || _ctx.state.data === undefined || _ctx.state.usuarios.length === 0,
                          apenasColaboradores: true
                        }, null, 8, ["empresas", "usuariosEspecificos", "codigoSelecionado", "onUpdate:codigoSelecionado", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_form_item, {
                      label: "Aberturas",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_abertura_caixa, {
                          caixa: _ctx.state.codigoCaixa,
                          usuario: _ctx.state.usuario,
                          data: _ctx.state.data,
                          codigoSelecionado: _ctx.state.codigoAberturaCaixa,
                          "onUpdate:codigoSelecionado": [
                            _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.codigoAberturaCaixa) = $event)),
                            _ctx.buscarAberturaCaixa
                          ]
                        }, null, 8, ["caixa", "usuario", "data", "codigoSelecionado", "onUpdate:codigoSelecionado"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, [
                        _createVNode(_component_icone, {
                          class: "ss-icone",
                          nome: "pesquisar"
                        })
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.buscarMovimentos())),
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.parametrosConsulta.valorBuscaRapida) = $event)),
                        class: "ant-input ss-alinhar-texto-esquerda",
                        placeholder: "Busca rápida: Digite o número de identificação, data, valor ou alguma informação para localizar a movimentação de caixa..."
                      }, null, 544), [
                        [_vModelText, _ctx.state.parametrosConsulta.valorBuscaRapida]
                      ])
                    ])
                  ])
                ]),
                (_ctx.state.aberturaCaixa.status === 3)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 0,
                      style: {"margin-top":"5px"},
                      message: 'Motivo da reabertura: ' + _ctx.state.motivoReabertura,
                      type: "info",
                      "show-icon": ""
                    }, null, 8, ["message"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_27, [
            ((!_ctx.state.apresentarResultados))
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_apuracao_caixa_totalizadores, {
                        saldoInicial: _ctx.state.apuracaoCaixa.saldoInicial,
                        totalEntradas: _ctx.state.apuracaoCaixa.totalEntradas,
                        totalSaidas: _ctx.state.apuracaoCaixa.totalSaidas,
                        saldoFinal: _ctx.state.apuracaoCaixa.totalFinal,
                        totalTransferido: _ctx.state.apuracaoCaixa.totalTransferido,
                        totalVendas: _ctx.state.apuracaoCaixa.totalVendas,
                        totalCancelado: _ctx.state.apuracaoCaixa.totalCancelado,
                        "total-devolvido": 0
                      }, null, 8, ["saldoInicial", "totalEntradas", "totalSaidas", "saldoFinal", "totalTransferido", "totalVendas", "totalCancelado"])
                    ])
                  ]),
                  _createVNode(_component_card, { titulo: "MOVIMENTOS DE CAIXA" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                        "data-source": _ctx.state.movimentos,
                        rowKey: "codigo",
                        pagination: false,
                        loading: _ctx.telaBase.carregando,
                        scroll: _ctx.storeSistema.state.layoutMobile?null: { y: _ctx.defineAlturaScroll(50) },
                        "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao },
                        size: "small"
                      }, {
                        headerCell: _withCtx(({ column }) => [
                          _createVNode(_component_coluna_grade, {
                            column: column,
                            ordenacaoSelecionada: _ctx.telaBase.ordenacaoSelecionada,
                            "onUpdate:ordenacaoSelecionada": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
                            filtrosCabecalho: _ctx.gradeBase.filtrosCabecalho,
                            "onUpdate:filtrosCabecalho": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.gradeBase.filtrosCabecalho) = $event)),
                            onBuscarDados: _cache[15] || (_cache[15] = ($event: any) => (_ctx.buscarMovimentos()))
                          }, null, 8, ["column", "ordenacaoSelecionada", "filtrosCabecalho"])
                        ]),
                        bodyCell: _withCtx(({ column, record, text }) => [
                          (column.key === 'Movimento')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createElementVNode("span", null, [
                                  _hoisted_35,
                                  _createTextVNode(" " + _toDisplayString(record.descricaoTipoDocumentoFinanceiro), 1)
                                ]),
                                _createElementVNode("span", null, [
                                  _hoisted_36,
                                  _createElementVNode("a", null, _toDisplayString(record.identificadorMovimento), 1)
                                ]),
                                ((record.nomePessoa))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                                      _hoisted_38,
                                      _createTextVNode(" " + _toDisplayString(record.nomePessoa), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", null, [
                                  _hoisted_39,
                                  _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataMovimento)), 1)
                                ]),
                                (record.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Pagamento)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                      _createVNode(_component_a_tag, { class: "ss-tag-tipo pagamento" }),
                                      _createTextVNode("Pagamento")
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                      _createVNode(_component_a_tag, { class: "ss-tag-tipo recebimento" }),
                                      _createTextVNode("Recebimento")
                                    ])),
                                _createElementVNode("span", null, [
                                  _hoisted_42,
                                  _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valor,2)), 1)
                                ])
                              ]))
                            : (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.visualizarMovimento(record.codigo))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(text), 1)
                                ], 8, _hoisted_43))
                              : (column.key === 'TipoMovimento')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    (record.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Pagamento)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createVNode(_component_a_tag, { class: "ss-tag-tipo pagamento" }),
                                          _createTextVNode("Pagamento ")
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createVNode(_component_a_tag, { class: "ss-tag-tipo recebimento" }),
                                          _createTextVNode("Recebimento ")
                                        ], 64))
                                  ], 64))
                                : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      _createElementVNode("a", {
                                        title: "Visualizar",
                                        onClick: ($event: any) => (_ctx.visualizarMovimento(record.codigo))
                                      }, [
                                        _createVNode(_component_icone, { nome: "visualizar" })
                                      ], 8, _hoisted_45),
                                      (_ctx.state.aberturaCaixa.status !== 2)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            title: "Excluir",
                                            onClick: ($event: any) => (_ctx.confirmarExclusao(record))
                                          }, [
                                            _createVNode(_component_icone, { nome: "excluir" })
                                          ], 8, _hoisted_46))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.storeSistema.state.layoutMobile? _ctx.UtilitarioData.aplicaFormatoDataAnoAbreviado(text):_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                          ((_ctx.storeSistema.state.layoutMobile && record.tipoMovimento === _ctx.ETipoMovimentoFinanceiro.Pagamento))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_48, "-" + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                                        ], 64))
                                      : _createCommentVNode("", true)
                        ]),
                        emptyText: _withCtx(() => [
                          _createVNode(_component_mensagem_sem_dados, {
                            resultadoPesquisa: !_ctx.telaBase.carregando,
                            mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum movimento no caixa encontrado com estes filtros.'
                          }, null, 8, ["resultadoPesquisa", "mensagem"])
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"])
                    ]),
                    _: 1
                  })
                ]))
          ])
        ])
      ])
    ]),
    _createVNode(_component_abertura_caixa_modal, {
      empresa: _ctx.state.empresa,
      caixa: _ctx.state.codigoCaixa,
      visivel: _ctx.state.exibirAbertura,
      "onUpdate:visivel": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.exibirAbertura) = $event)),
      onConfirmacao: _ctx.buscarOperadores
    }, null, 8, ["empresa", "caixa", "visivel", "onConfirmacao"]),
    _createVNode(_component_fechamento_caixa_modal, {
      empresa: _ctx.state.empresa,
      caixa: _ctx.state.caixa,
      abertura: _ctx.state.aberturaCaixa,
      visivel: _ctx.state.exibirFechamento,
      "onUpdate:visivel": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.exibirFechamento) = $event)),
      onConfirmacao: _ctx.buscarOperadores
    }, null, 8, ["empresa", "caixa", "abertura", "visivel", "onConfirmacao"]),
    _createVNode(_component_reabertura_caixa_modal, {
      empresa: _ctx.state.empresa,
      caixa: _ctx.state.caixa,
      abertura: _ctx.state.aberturaCaixa,
      visivel: _ctx.state.exibirReabertura,
      "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.exibirReabertura) = $event)),
      onConfirmacao: _ctx.buscarOperadores
    }, null, 8, ["empresa", "caixa", "abertura", "visivel", "onConfirmacao"]),
    _createVNode(_component_movimento_caixa_modal, {
      empresa: _ctx.state.empresa,
      caixa: _ctx.state.caixa,
      abertura: _ctx.state.aberturaCaixa,
      codigoMovimento: _ctx.state.codigoMovimentacao,
      visivel: _ctx.state.exibirLancamento,
      "onUpdate:visivel": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.exibirLancamento) = $event)),
      onConfirmacao: _ctx.buscarAberturaCaixa
    }, null, 8, ["empresa", "caixa", "abertura", "codigoMovimento", "visivel", "onConfirmacao"]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"])
  ]))
}